export const titleCodes = {
    
    dosmeticTitle: {
        code: "${merchantId}_tmpl_title_13",
        title: 'Domestic Shipping'
    },

    internationalTitle: {
        code: "${merchantId}_tmpl_title_14",
        title: 'International Shipping'
    },

    singaporeTitle: {
        code: "${merchantId}_tmpl_title_15",
        title: 'Singapore:'
    },

    australiaTitle: {
        code: "${merchantId}_tmpl_title_16",
        title: 'Australia:'
    },
}

export const textCodes = {
    
    domesText1: {
        code: "${merchantId}_tmpl_text_21",
        text: 'You can track your order anytime at https://www.ninjavan.co/en-mm/tracking.'
    },

    domesText2: {
        code: "${merchantId}_tmpl_text_22",
        text: "Transit time is estimated 2-5 working days depending on the region."
    },

    domesText3: {
        code: "${merchantId}_tmpl_text_23",
        text: "*Note –Transit time is subjected to delays based on unforeseeable events."
    },

    domesText4: {
        code: "${merchantId}_tmpl_text_24",
        text: "Shipping fee: Cash on delivery based on Ninja Van published rates."
    },

    interText1: {
        code: "${merchantId}_tmpl_text_25",
        text: "We are currently shipping to Singapore and Australia only."
    },

    singText1: {
        code: "${merchantId}_tmpl_text_26",
        text: "Flat rate SGD$12.00 to Singapore up until 1kg, SGD 8.00 per additional kg."
    },

    singText2: {
        code: "${merchantId}_tmpl_text_27",
        text: "You can track your order anytime at https://www.ninjavan.co/en-sg/tracking once the shipment is received by our Singapore logistics partner."
    },

    singText3: {
        code: "${merchantId}_tmpl_text_28",
        text: "Transit time is estimated 6-9 working days depending on the postal code."
    },

    ausiText1: {
        code: "${merchantId}_tmpl_text_29",
        text: "Door to door (With tracking number): SGD 44.00 (up till 1kg), SGD 28.5 per additional kg."
    },

    ausiText2: {
        code: "${merchantId}_tmpl_text_30",
        text: "Door to door (Without tracking number): SGD 39.00 (up till 1kg), SGD 32.5 per additional kg."
    },

    ausiText3: {
        code: "${merchantId}_tmpl_text_31",
        text: "You can track your order anytime at https://www.singpost.com/ once the shipment is received by our Singapore logistics partner."
    },

    ausiText4: {
        code: "${merchantId}_tmpl_text_32",
        text: "Transit time is estimated 10-17 working days depending on the postal code."
    },

    ausiText5: {
        code: "${merchantId}_tmpl_text_33",
        text: "*Note - Rates & transit times are subjected to change based on unforeseeable events."
    }
}
